import { isCustomerRole } from "@/constants/customerNav";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Gift } from "lucide-react";
import { useState } from "react";
import { LabelBranding, SubsidiaryPicker } from "@/components/welcome/LabelBranding";

const EDIT_ROLES = ["customer_global_admin", "customer_it_admin"];

export default function WelcomeLabelBranding() {
  const { user } = useAuth();
  const canEdit = EDIT_ROLES.includes(user?.role);
  const [sub, setSub] = useState({ id: "", label: "" });
  if (user && !isCustomerRole(user.role)) return <Navigate to="/admin/welcome-labels?tab=branding" replace />;
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-4 md:p-8" data-testid="customer-label-branding">
      <div className="flex items-center gap-3">
        <div className="grid h-11 w-11 place-items-center rounded-xl bg-teal-700 text-white"><Gift className="h-5 w-5" /></div>
        <div><h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }}>Welcome label branding</h1>
          <p className="text-sm text-slate-500">Add your logo and a welcome line to the card your employees find inside every SUNTRONIX delivery.</p></div>
      </div>
      {!canEdit && <div className="rounded-md bg-sky-50 px-3 py-2 text-xs text-sky-900" data-testid="branding-readonly-note">Only your organisation's admins can change this. You can view the current branding.</div>}
      {user?.master_company_id && <SubsidiaryPicker cid={user.master_company_id} value={sub.id} label={sub.label} onChange={(id, l) => setSub({ id, label: l })} />}
      <LabelBranding key={sub.id || "org"} cid={sub.id || user?.master_company_id} canEdit={canEdit} />
    </div>
  );
}
